import { useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';

/**
 * Single source of truth for "is the horizontal menu in charge right now?".
 *
 * Layout.js, Menu.js and AppBar.js all need this answer and must agree - if
 * they disagreed you could end up with a visible but empty sidebar, or two
 * menus at once. Keep the breakpoint in this one place.
 *
 * Below md the horizontal bar cannot fit ten sections, so the sidebar takes
 * over regardless of the saved preference.
 */
const useTopMenu = () => {
    const menuLayout = useSelector(state => state.menuLayout);
    const isNarrow = useMediaQuery(theme => theme.breakpoints.down('sm'));
    return menuLayout === 'top' && !isNarrow;
};

export default useTopMenu;
